<template>
    <div id="volunteer">
        <Topbar v-if="this.$store.state.topbar_actions_visible" @action="fnAction"></Topbar>
        <v-container class="main left">
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm6 md3 class="logo" >
                    <img :src="( volunteer.avatar )? volunteer.avatar : '/img/avatar.svg'" />
                </v-flex>
                <v-flex xs12 sm6 md9 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 class="name">{{ $t( "params.user_information" ) }}</v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.name" ) }}:</div>
                                <div class="value">{{ volunteer.name | checkParam }}</div>
                                <div class="label">{{ $t( "params.username" ) }}:</div>
                                <div class="value">{{ volunteer.username | checkParam }}</div>
                                <div class="label">{{ $t( "params.parent_document" ) }}:</div>
                                <div class="value">{{ volunteer.dni | checkParam }}</div>
                                <div class="label">
                                    <Phone :phone="$t( 'params.phone' ) + ':'"></Phone>
                                </div>
                                <div class="value">{{ volunteer.phone | checkParam }}</div>
                                <div class="label">{{ $t( "params.birthday" ) }}:</div>
                                <div class="value">{{ volunteer.birthday | checkParam | showDate }} ({{volunteer.age}})</div>
                                <div class="label">{{ $t( "params.city" ) }}:</div>
                                <div class="value">{{ volunteer.city | checkParam }}</div>

                                <div class="label">{{ $t( "params.drive" ) }}:</div>
                                <div class="value">{{ volunteer.b_carnet | checkParam }}</div>

                                <!-- ALERGY -->
                                <!-- <div class="label" v-if="volunteer.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="volunteer.b_alergy" class="value">{{ volunteer.alergy_text | checkParam }}</div>
                                <div class="label" v-if="!volunteer.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="!volunteer.b_alergy" class="value">{{ "false" | checkParam }}</div> -->               
                               
                                <!-- <div class="label">{{ $t( "params.how_meet" ) }}:</div>
                                <div class="value">{{ volunteer.how_meet | checkParam }}</div> -->
                            </v-flex>
                            <v-flex xs12 md6>
                                <div class="label">{{ $t( "params.surname" ) }}:</div>
                                <div class="value">{{ volunteer.surname | checkParam }}</div>
                                <div class="label">{{ $t( "params.gender" ) }}:</div>
                                <div class="value">{{ $t(volunteer.gender) | checkParam }}</div>
                                <div class="label">
                                    <Email :email="$t( 'params.email' ) + ':'"></Email>
                                </div>
                                <div class="value">{{ volunteer.email | checkParam }}</div>
                                <div class="label">
                                    <Phone :phone="$t( 'params.phone2' ) + ':'"></Phone>
                                </div>
                                <div class="value">{{ volunteer.phone2 | checkParam }}</div>
                                <div class="label">{{ $t( "params.cp" ) }}:</div>
                                <div class="value">{{ volunteer.cp | checkParam }}</div>
                                <div class="label">{{ $t( "params.country" ) }}:</div>
                                <div class="value">
                                    <Country v-if="volunteer.country_id" :country="country"></Country>
                                </div>
                                <div class="label">{{ $t( "params.instagram" ) }}:</div>
                                <a target="_blank" :href="'https://www.instagram.com/' + volunteer.instagram.substr(1)" v-if="volunteer.instagram != undefined"><div class="value" >{{ volunteer.instagram }}</div></a>
                                <div class="value" v-else>{{ volunteer.instagram | checkParam }}</div>
                                <!-- <div class="label">{{ $t( "params.other_alergy" ) }}:</div><div class="value">{{ volunteer.other_allergies | checkParam }}</div> -->
                                <div class="label">
                                    {{$t( 'params.num_ss' )}}
                                </div>
                                <div class="value">{{ volunteer.num_ss | checkParam }}</div>

                            </v-flex>

                        </v-layout>
                    </v-container>
                </v-flex>

                <v-flex xs12 sm12 md12 class="info ">
                    <v-container>
                        <v-layout row wrap class="section">
                            <v-flex xs12 sm12 md12 class="info" v-if="this.$store.getters.isEventSelected">
                                <v-container>
                                    <v-layout row wrap class="section">
                                        <v-flex v-if="this.$store.getters.isEventSelected" xs12 class="name">{{ $t( "volunteers.necessary_information" ) }}</v-flex>
                                        <v-flex xs12 md6>
                                            <div class="label" v-if="volunteer.b_alergy && volunteer.b_alergy != null">{{ $t( "params.alergies" ) }}:</div><div v-if="volunteer.b_alergy && volunteer.b_alergy != null" class="value">{{ volunteer.alergy_text | checkParam }}</div>
                                            <div class="label" v-if="!volunteer.b_alergy">{{ $t( "params.alergies" ) }}:</div><div v-if="!volunteer.b_alergy" class="value">{{ "false" | checkParam }}</div>
                                            <div class="label">{{ $t( "params.other_alergy" ) }}:</div><div class="value">{{ volunteer.other_allergies | checkParam }}</div>
                                            <div class="label" v-if="volunteer.diet && volunteer.diet != null">{{ $t( "params.diet" ) }}:</div><div class="value" v-if="volunteer.diet && volunteer.diet != null">{{ $store.state.diet[ volunteer.diet ].name | checkParam | i18n }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.observations" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.observations | checkParam }}</div>
                                        </v-flex>
                                        <v-flex xs12 md6>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.years_on_mic" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.years_mic | checkParam }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.num_cc" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.num_cc | checkParam }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.contract" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.contract | checkParam }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.day_of_arrival" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.day_of_arrival | showDate }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.day_of_exit" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.day_of_exit | showDate }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.estimate_arrival" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.estimate_arrival | i18n | checkParam }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.arrival_site" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ 'info_volunteer_arrival.' + current_event.name.toLowerCase().replace(/ /g, '-') + '.arrival_site.' + event_info.arrival_site | i18n | checkParam }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.take_car" ) }}:</div><div class="value" v-if="typeof event_info !== 'undefined'">{{ event_info.have_car | checkParam }}</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.leave_from" ) }}:</div><div class="value" v-if="event_info.have_car">{{ event_info.leave_from | checkParam }}</div><div v-else class="value">-</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.car_seats" ) }}:</div><div class="value" v-if="event_info.have_car">{{ event_info.car_seats | checkParam }}</div><div v-else class="value">-</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "campus.shirt_size" ) }}:</div><div v-if="event_info.shirt_size && event_info.shirt_size != null" class="value">{{ $store.state.volunteer_shirt_size[ event_info.shirt_size ].name | i18n | checkParam }}</div><div v-else class="value">-</div>
                                            <div class="label" v-if="typeof event_info !== 'undefined'">{{ $t( "params.shoes_size" ) }}:</div><div v-if="event_info.shoes_size && event_info.shoes_size != null" class="value">{{ ( $store.state.volunteer_shoes_size[ event_info.shoes_size ].ue + " " + ( $store.state.volunteer_shoes_size[ event_info.shoes_size ].sex == "1"? $t( 'man') : $t('woman') ) ) | checkParam }}</div><div v-else class="value">-</div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>
                            <v-flex xs12 sm12 md12 class="info" v-if="this.$store.getters.isEventSelected">
                                <v-container>
                                    <Documents :id="id" :event="this.$store.getters['events/getCurrentEvent']().id"></Documents>
                                </v-container>
                            </v-flex>

                            <v-flex xs12 sm12 md12 class="info" v-if="this.$store.getters.isEventSelected">
                                <v-container>
                                    <v-flex xs12>
                                    <div class="name">{{ $t("params.assigned_teams") }}</div>

                                    <v-layout row wrap class="assigned-teams">
                                        <v-flex
                                        v-for="(rel, index) in volunteer_rel_event_entity_list"
                                        :key="index"
                                        xs12 sm6 md4
                                        class="team-card"
                                        >
                                        <v-card class="pa-3" outlined tile>
                                            <v-layout align-center>
                                                <v-flex shrink>
                                                <img
                                                    v-if="rel.team && rel.team.club_shield"
                                                    :src="rel.team.club_shield"
                                                    alt="Shield"
                                                    style="height: 40px; margin-right: 10px;"
                                                />
                                                </v-flex>
                                                <v-flex>
                                                <div class="team-name">
                                                    {{ rel.team && rel.team.name ? rel.team.name : '-' }}
                                                    <span v-if="rel.team && rel.team.category_max_age">
                                                    ({{ rel.team.category_max_age }})
                                                    </span>
                                                </div>
                                                <div class="club-name">
                                                    {{ rel.team && rel.team.club_name ? rel.team.club_name : '-' }}
                                                </div>
                                                </v-flex>
                                                <v-flex shrink>
                                                <v-btn icon small @click="promptDelete(rel)">
                                                    <v-icon color="black">close</v-icon>
                                                </v-btn>
                                                </v-flex>
                                            </v-layout>
                                            </v-card>
                                        </v-flex>
                                    </v-layout>

                                    <div v-if="!volunteer_rel_event_entity_list || volunteer_rel_event_entity_list.length == 0" class="value">
                                        {{ $t("undefined") }}
                                    </div>
                                    </v-flex>
                                </v-container>
                            </v-flex>

                            <v-flex xs12 class="name">{{ $t( "titles.interest" ) }}</v-flex>
                            <v-container>
                                    <v-layout row wrap class="section">
                                        <v-flex xs12 md6>
                                            <div class="label">{{ $t( "params.cv" ) }}:</div>
                                            <a target="_blank" :href="volunteer.cv" v-if="volunteer.cv != undefined"><div class="value" >{{ $t( "preview" ) }}</div></a>
                                            <div class="value" v-else>-</div>
                                            <div class="label">{{ $t( "params.ss" ) }}:</div>
                                            <a target="_blank" :href="volunteer.ss" v-if="volunteer.ss != undefined"><div class="value" >{{ $t( "preview" ) }}</div></a>
                                            <div class="value" v-else>-</div>
                                            <div class="label">{{ $t( "params.dni" ) }}:</div>
                                            <a target="_blank" :href="volunteer.dni_file" v-if="volunteer.dni_file != undefined"><div class="value" >{{ $t( "preview" ) }}</div></a>
                                            <div class="value" v-else>-</div>
                                        </v-flex>
                                        
                                    </v-layout>
                                </v-container>

                            <table v-if="volunteer.event != null" style="margin-bottom: 10px">
                                <thead>
                                    <th style="min-width: 400px;">{{ $t( "params.event" ) }}</th>
                                    <th>{{ $t( "params.role" ) }}</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in volunteer.event">
                                        <td v-if="item.id != '' && item.id[0] != ''"><p v-for="(subitem, subindex) in item.id"> {{ getEvent(subitem)? getEvent(subitem).name + " " + getEvent(subitem).edition : '' }}<br></p></td>
                                        <td v-if="item.id != '' && item.id[0] != ''"><span v-for="(subitem, subindex) in item.role"> {{ 'role_volunteer_event.' + role_volunteer[subitem].name | i18n }}<span v-if="Object.values(item.role).length > 1 && Object.values(item.role).length != subindex+1 ">, </span> </span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <span v-else>{{ $t( "undefined") }}</span>

                            <v-flex xs12 class="player">
                                <template v-if="referee">
                                    <div class="label">{{ $t( "params.referee_experience" ) }}</div>
                                    <div class="value">{{ volunteer.referee_experience | checkParam }}</div>

                                    <div class="label">{{ $t( "volunteer_form_literals.3po" ) }}</div>
                                    <div class="value" v-if="volunteer.referee_3po">{{ $t( 'volunteer_form_literals.3po_' + volunteer_3po_options[volunteer.referee_3po].name) | checkParam }}</div>
                                    <div class="value" v-else>{{ volunteer.referee_3po | checkParam }}</div>
                                </template>

                                <template v-if="marketing">
                                    <table style="margin-bottom: 10px">
                                        <thead>
                                            <th style="min-width: 200px;">{{ $t( "params.reference" ) }}</th>
                                        </thead>
                                        <tbody>
                                            <tr v-if="volunteer.event != null" v-for="(item, index) in volunteer.rrss">
                                                <td>{{ item.url }}</td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </template>
                            </v-flex>

                            <v-flex xs12 class="name">{{ $t( "params.working_areas" ) }}</v-flex>
                            <table v-if="volunteer.working_areas && volunteer.working_areas.length > 0" style="margin-bottom: 10px">
                                <tbody>
                                    <tr v-for="(item, index) in volunteer.working_areas.split(',')">
                                        <td>{{ 'working_areas.' + working_areas[item].name | i18n }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <template v-else>
                                Sense dades
                            </template>
                            


                            <v-flex xs12 class="name">{{ $t( "params.studies" ) }}</v-flex>
                            <table v-if="volunteer.studies" style="margin-bottom: 10px">
                                <tbody>
                                    <tr v-for="(item, index) in volunteer.studies.split(',')">
                                        <td>{{ 'studies.' + studies[item].name | i18n }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <v-flex xs12 class="player">
                                <template v-if="volunteer.other_studies">
                                        <div class="label">{{ $t( "params.other_studies" ) }}</div>
                                        <div class="value">{{ volunteer.other_studies | checkParam }}</div>
                                </template>
                            </v-flex>

                            <v-flex xs12 md6>                                     
                                            <div class="label">{{ $t( "params.ropec" ) }}:</div>
                                            <div class="value">{{ volunteer.ropec | checkParam }}</div>
                                            

                                        </v-flex>

                            <v-flex xs12 class="name">{{ $t( "params.language" ) }}</v-flex>
                            <table style="margin-bottom: 10px">
                                <thead>
                                    <th style="min-width: 200px;">{{ $t( "params.language" ) }}</th>
                                    <th>{{ $t( "params.level" ) }}</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in volunteer.idiomas">
                                        <td>{{ 'language_volunteer.' + language_volunteer[item.lang].name | i18n }}</td>
                                        <td>{{ item.level }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <v-flex xs12 class="name">{{ $t( "params.sport_degrees" ) }}</v-flex>
                            <table v-if="volunteer.staff_level != null" style="margin-bottom: 10px">
                                <tbody>
                                    <tr v-for="(item, index) in volunteer.staff_level">
                                        <td>{{ 'staff_level.' + staff_level[item].name | i18n }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <span v-else>{{ $t( "undefined") }}</span>

                            <v-flex xs12 class="player">
                                <template v-if="volunteer.other_staff_level">
                                        <div class="label">{{ $t( "params.other_sport_degrees" ) }}</div>
                                        <div class="value">{{ volunteer.other_staff_level | checkParam }}</div>
                                </template>
                                <template v-if="volunteer.other_cafe">
                                        <div class="label">{{ $t( "params.other_cafe" ) }}</div>
                                        <div class="value">{{ volunteer.other_cafe | checkParam }}</div>
                                </template>
                                <template v-if="volunteer.official_basket">
                                        <div class="label">{{ $t( "params.official_basket" ) }}</div>
                                        <div class="value" v-if="volunteer.official_basket == '1'">{{ $t( "bool.si" ) }}</div>
                                        <div class="value" v-else-if="volunteer.official_basket == '2'">{{ $t( "bool.no" ) }}</div>
                                        <div class="value" v-else-if="volunteer.official_basket == '3'">{{ $t( "bool.no_but_experience" ) }}</div>
                                        <div class="value" v-else="volunteer.official_basket == null">-</div>
                                </template>
                            </v-flex>

                            <v-flex xs12 class="name">{{ $t( "historical" ) }}</v-flex>
                            <table v-if="volunteer.events_done != null" style="margin-bottom: 10px">
                                <thead>
                                    <th style="min-width: 200px;">{{ $t( "params.event" ) }}</th>
                                    <th style="min-width: 400px;">{{ $t( "params.role" ) }}</th>
                                    <th>{{ $t( "years" ) }}</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in volunteer.events_done">
                                        <td v-if="item.events != null && typeof item.events === 'string'"><span v-for="(item2, index) in item.events.split(',')">{{ event_types[item2] ? event_types[item2].name : '' }}</span></td>
                                        <td v-else-if="item.events != null"><span v-for="(item2, index) in item.events">{{ event_types[item2] ? event_types[item2].name : '' }}</span></td>
                                        <td>{{ ( role_volunteer[item.role] ? 'role_volunteer_event.' + role_volunteer[item.role].name : '' ) | i18n }}</td>
                                        <td><span v-for="(subitem, subindex) in item.year">{{ subitem }}<span v-if="item.year.length > 1 && item.year.length != subindex+1">, </span></span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <span v-else>{{ $t( "undefined") }}</span>
                        </v-layout>
                    </v-container>
                </v-flex>
    
            </v-layout>
            <v-layout row wrap class="section-container" id="basic">
                <v-flex xs12 sm12 md12 class="info">
                    <v-container>
                        <v-layout row wrap class="section">
                            <LastUpdate :data="volunteer.user_modify"></LastUpdate> 
                        </v-layout>
                    </v-container>
                </v-flex>
            </v-layout>
            <v-layout row wrap class="section-container" id="notes">
                <NoteList :notes="volunteer.notes" :page="'volunteer'" :id="id" @create_note="createNote"></NoteList>
            </v-layout>
        </v-container>
        <assign-team-dialog
        :value="assignTeamDialogVisible"
        @assign="handleAssignTeam"
        @input="assignTeamDialogVisible = false"
        :loading="isAssigningTeam"
        ref="assignTeamDialog"
        />
        <delete-rel-entity-event-dialog
        :value="showDeleteDialog"
        @confirm="confirmDeleteTeam"
        @input="showDeleteDialog = false"
        />
        <!-- <ContactRelationsList :contacts_rel="volunteer.current_roles" class="contact right"></ContactRelationsList> -->
    </div>
</template>

<script>

import i18n from '@/i18n'
import NoteList from '@/components/ui/NoteList'
import TeamCard from '@/components/ui/cards/mini/Team'
import Topbar from '@/components/ui/Topbar'
import Documents from "@/components/ui/Documents"
import AssignTeamDialog from "@/components/ui/AssignTeamDialog.vue"
import DeleteRelEntityEventDialog from "@/components/ui/DeleteRelEntityEventDialog"

import ContactRelationsList from '@/components/ui/ContactRelationsList'

import Phone from '@/components/ui/labels/Phone'
import Email from '@/components/ui/labels/Email'
import Country from '@/components/ui/labels/Country'
import LastUpdate from '@/components/ui/LastUpdate'

export default {
  name: 'CardVolunteer',
  components: { NoteList, TeamCard, Topbar, Phone, Email, Country, ContactRelationsList, LastUpdate, Documents, AssignTeamDialog, DeleteRelEntityEventDialog },
  props: { },
  data () {
    return {
      id: this.$route.params.id,
      current_roles: [],
      event_info: {},
      assignTeamDialogVisible: false,
      isAssigningTeam: false,
      showDeleteDialog: false
    }
  },
  computed: {

    volunteer() {
        var oVolunteer = {...this.$store.getters[ 'volunteers/get_by_id' ]( this.$route.params.id )};
        if( !oVolunteer ) oVolunteer = {};

        oVolunteer.gender = ( oVolunteer.gender != null )? 'gender.' + oVolunteer.gender : null
        oVolunteer.age = moment().diff(oVolunteer.birthday, 'years');
        oVolunteer.notes = ObjectToArray( oVolunteer.notes );
        oVolunteer.notes.sort( function( n1, n2 ){
          if( moment( n1.last_update ).valueOf() < moment( n2.last_update ).valueOf() ) return 1
          return -1
        })
        typeof oVolunteer.idiomas === 'string' ? oVolunteer.idiomas=JSON.parse(oVolunteer.idiomas.split(',')[0]+',"level":"Alt"}]'):true;
        if( typeof oVolunteer.current_roles === 'undefined' ) oVolunteer.current_roles = []
        else{
            oVolunteer.current_roles.forEach( role => {
                role.visible = true
            })
        }

        oVolunteer.alergy_text = ''
        if( oVolunteer.b_alergy && oVolunteer.b_alergy != null ){
            var alergies = this.$store.state.persons.alergies;
            if( typeof oVolunteer.alergy !== 'undefined' && oVolunteer.alergy != null ){
                oVolunteer.alergy.split(',').forEach( alergy => {
                    if( alergy != null && alergy != "null" ){
                        oVolunteer.alergy_text+= ( oVolunteer.alergy_text != '' ? ',' : '' )
                        oVolunteer.alergy_text+= i18n.t( alergies[ parseInt( alergy ) ].name ) 
                    }
                })
            }
        }

        this.current_roles = oVolunteer.current_roles
        return oVolunteer
    },

    country() {
        if (this.volunteer.country_id) {
            return { ...this.$store.getters.getCountryByID(this.volunteer.country_id) };
        }
            return {};
    },

    referee() {
        var referee = Object.values(this.role_volunteer).find(obj => {
            return obj.name == "referee_category" && obj.parent_id == null;
        });

        var positions = [];

        for ( var item in this.volunteer.event ) {
            for ( var subitem in this.volunteer.event[item].role ) {
                if (this.volunteer.event[item].role[subitem] == referee.id) {
                return true
                }
            }
        };
        return false;
    },

    marketing() {
        var marketing = Object.values(this.role_volunteer).find(obj => {
            return obj.name == "marketing_communication" && obj.parent_id == null;
        });

        var positions = [];

        for ( var item in this.volunteer.event ) {
            for ( var subitem in this.volunteer.event[item].role ) {
                if (this.volunteer.event[item].role[subitem] == marketing.id) {
                return true
                }
            }
        };
        return false;
    },

    events() {
        return this.$store.getters["events/getList"]();
    },

    event_types() {
        var et = this.$store.getters["events/getEventType"]();
        return et;
    },

    how_meet() {
        return this.$store.getters["getHowMeet"];
    },

    studies() {
        return this.$store.getters["getStudies"];
    },

    working_areas() {
        return this.$store.getters["getWorkingAreas"];
    },

    staff_level() {
        return this.$store.getters["getStaffLevel"]();
    },

    language_volunteer() {
        return this.$store.getters["getLanguageVolunteer"];
    },

    role_volunteer() {
        return this.$store.getters["getRoleVolunteer"];
    },

    volunteer_3po_options() {
        return this.$store.getters["get3poOptions"];
    },

    current_event() {
        return this.$store.getters['events/getCurrentEvent']();
    },

    volunteer_rel_event_entity_list() {
        return this.$store.getters['volunteers/getRelEventEntityList']();
    }

  },
  async created() {
    this.$store.commit("setTopbarActionsVisible", true);
    this.$store.commit("setMenuVisible", true);
    await this.loadDataPage(true);
  },
  methods: {
    createNote(){
        this.$card.note( { current_page: 'volunteer', current_id: this.$route.params.id } );
    },

    createContactRelationship(){
        this.$card.contactrel( { current_page: 'volunteer', current_id: this.$route.params.id } );
    },

    getCountry( id ){
        if( id ){
            return {...this.$store.getters.getCountryByID( id ) };
        }
        return false;
    },

    fnAction( emit ){
        if( typeof emit.action === 'undefined' || emit.action == null ) return
        switch( emit.action ){
            case 'remove':              this.fnRemove( emit.params )
                                        break
            case 'create_note':         this.createNote( emit.params )
                                        break
            case 'rel_volunteer_event': this.fnRelVolunteerEvent( emit.params )
                                        break
            case 'destroy':             this.fnDestroy( emit.params )
                                        break
            case 'mic_preview':         this.$root.fnGoToTeamZones( 30 );
                                         break;
            case 'mic_assign_team':
                this.fnAssignTeam();
                break;
        }
    },

    getEvent(id){
        return this.$store.getters["events/getList"](id);
    },

    fnRemove() {
    var self = this;
    this.$popup.confirm(
        {
          message: i18n.t("volunteers.remove_message"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel")
        },
        function() {
           var event = self.$store.getters.isEventSelected ? self.$store.getters["events/getCurrentEvent"]() : false;
           var event_id = event ? event.id : false
          self.$store.dispatch("volunteers/remove", { volunteer: self.id, event: event_id}).then(function() {
            var page = event ? "event_" : "";
                page = page + "volunteers";
                
            self.$router.push({
              name: page,
              params: {
                event: event
                  ? self.$root
                      .formatEventUrl(event.name, event.edition)
                      .replace("/event/", "")
                  : null
              }
            });
          });
        }
      );
    },

    getPosition( position ){
        var pos = this.$store.getters[ 'volunteers/getPosition']( position )
        if( pos && typeof pos.name !== 'undefined' ){
            return pos.name
        }

        return null
    },

    editRole( key ){            
        var event = ( this.$store.getters.isEventSelected )? this.$store.getters[ 'events/getCurrentEvent' ]() : false;
            event = ( event )? this.$root.formatEventUrl( event.name, event.edition ).replace( '/event/', '' ) : null
        var page = ( event )? 'event_' : ''
            page = page + 'volunteers_role_edit'
        var role = this.volunteer.current_roles[ key ]

        var type = ""
        switch( parseInt( role.contact_type_id ) ){
            case 107:   type = 'player'
                        break
            case 5:
            case 108:
            case 6:     type = 'manager'
                        break
            case 1:     
            case 2:     type = 'staff'

            case 111:   type = 'team'
                        break
        }
        
        this.$router.push( { name: page, params: { event: event, id: this.volunteer.id, role_id: role.id, type: type } } )
    },

    fnRelVolunteerEvent() {
        if (!this.$store.getters.isEventSelected) {
        var self = this;
        this.$card.relVolunteerEvent({
          event_id: this.$store.getters["events/getCurrentEvent"]().id,
          callBack: function(plug, params, store) {
            self.$store
              .dispatch("volunteers/addRelVolunteerEvent", {
                event_id: plug.params.event.value, volunteer_id: self.volunteer.id
              })
              .then(function() {
                self.$popup.alert({
                  message: i18n.t("volunteers.created_rel_volunteer_event"),
                  btnSuccess: i18n.t("accept")
                });
                self.$card.close();
              })
              .catch(function(e) {
                self.$popup.alert({
                  message: i18n.t("errors." + e),
                  btnSuccess: i18n.t("accept")
                });
              });
          }
        });
      } else {
        this.$popup.alert({
          message: i18n.t("volunteer.exists_rel_volunteer_event"),
          btnSuccess: i18n.t("accept")
        });
      }
    },

    fnDestroy(){
        this.$destroy()
    },
    fnAssignTeam() {
        this.assignTeamDialogVisible = true;
    },
    async handleAssignTeam({ teamId }) {
        const data = {
            volunteer_id: this.$route.params.id,
            event_id: this.$store.getters['events/getCurrentEvent']().id,
            entity_type: 2, // 2 is the type for teams
            entity_id: teamId
        }
        this.isAssigningTeam = true

        try {
            await this.$store.dispatch('volunteers/assign_volunteer_to_team', data)

            this.assignTeamDialogVisible = false
            this.loadDataPage(true)
        } catch (error) {
            console.log('notify', { type: 'error', message: 'Failed to create' })
        } finally {
            this.isAssigningTeam = false
            this.$refs.assignTeamDialog.resetState()
        }
    },
    async loadDataPage(forceReload = false) {
        this.$overlay.loading();
        const id = this.$route.params.id;
        const eventId = this.$store.getters["events/getCurrentEvent"]().id;

        try {
            if (forceReload) {
            await this.$store.dispatch("events/loadList", {
                page_options: { num_page: -1, num_items: -1 },
            });
            }

            await this.$store.dispatch("volunteers/load_by_id", { id: id });
            await this.$store.dispatch("volunteers/fetchVolunteerRelEventEntity", {
            id: id,
            event: eventId,
            });

            if (this.$store.getters.isEventSelected) {
            const eventId = this.$store.getters["events/getCurrentEvent"]().id;
            const response = await this.$store.dispatch(
                "volunteers/loadRelVolunteerEvent",
                {
                person_id: id,
                event_id: eventId,
                }
            );

            this.event_info = response;
            this.event_info.have_car = this.event_info.have_car === "1";
            }
        } finally {
            this.$overlay.hide();
        }
    },
    promptDelete(rel) {
        this.teamToDelete = rel;
        this.showDeleteDialog = true;
    },

    async confirmDeleteTeam() {
        if (!this.teamToDelete) return;

        const payload = {
            volunteer_id: this.id,
            event_id: this.current_event.id,
            entity_type: 2,
            entity_id: this.teamToDelete.entity_id
        };

        try {
            await this.$store.dispatch('volunteers/delete_volunteer_team_assignment', payload);
            await this.loadDataPage(); // refresh view
        } catch (e) {
            this.$popup.alert({ message: this.$t('error.generic'), btnSuccess: this.$t('accept') });
        } finally {
            this.$overlay.hide();
            this.teamToDelete = null;
            this.showDeleteDialog = false;
        }
    }

  },
    filters: {
        formatType( value ){
            switch (value) {
                case null:
                    return "";
                    break;
                case 1:
                    return "Administrador Backoffice";
                    break;
                case 3:
                    return "Administrador MicCamps";
                    break;
                case 4:
                    return "Usuari MicCamps";
                    break;
                case 10:
                    return "Administrador club ZonaEquipos";
                    break;
                case 11:
                    return "Usuari team ZonaEquipos";
                    break;
                case 20:
                    return "Player Campus";
                    break;
            }    
        }
    }
}
</script>

<style lang="scss" scoped>

.team-card {
  padding: 5px;
}

.team-name {
  font-weight: 600;
  font-size: 14px;
}

.club-name {
  font-size: 13px;
  color: #555;
}
    #volunteer {
        width: 100%;
        display: inline-block;

        .container {
            width: calc( 100% );
            padding: 0px;
            max-width: 100%;

            &.main {
                overflow-y: auto;
                height: calc( 100vh - 110px );
            }

            .section-container {
                padding: 20px;
                
                &#basic {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: 3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
                &#notes {
                    background-color: $complem-color-light; 
                }
                &#teams {
                    background-color: #fff;
                    @include  box-shadow( $h: 0px , $v: -3px , $b: 8px , $s: 0px , $c: #00000011 );
                }
            }
        }

        th {
            font-weight: bold;
        }

        .contact {
            width: 20%;
            width: 350px;
            padding: 20px;
        }
    
        .logo {
            width: 150px;
            height: 150px;
            border-radius: 50%;

            img {
                object-fit: contain;
                object-position: center;
                height: 100%;
                width: auto;
                margin: 0 auto;
                display: block;
                margin-top: 50px;
                opacity: 0.5;
            }
        }
        .info {

            .container {
                margin: 0;
                padding: 0 20px;
                padding-left: 40px;
                width: 100%;

                .section {
                    margin-bottom: 25px;

                    .name {
                        font-weight: lighter;
                        font-size: 24px;
                        @include font-size(14px);
                        border-bottom: 1px solid #ddd;
                        margin: 10px 0 20px 0;
                        color: $main-color;
                        text-transform: uppercase;
                        margin-bottom: 20px;
                        border-bottom: 2px solid $complem-color-dark;
                        color: $complem-color-dark;
                    }

                    .label {
                        font-family: $text-light;
                        @include font-size(14px);
                        width: 40%;
                        float: left;
                        line-height: 20px;
                    }

                    .value {
                        font-family: $text;
                        font-weight: lighter;
                        @include font-size(14px);
                        width: 60%;
                        float: left;
                        margin-bottom: 10px;
                    }

                    .edit {
                        background-image: url(/img/edit-b.svg);
                        background-size: 15px;
                        background-repeat: no-repeat;
                        background-position: left center;
                        position: absolute;
                        right: 0;
                        top: -5px;
                        padding-left: 20px;
                        text-transform: none;
                        font-weight: bold;
                    }
                }
            }

            &.role .name {
                position: relative;
                width: fit-content;
                cursor: pointer;

                &::after {
                    content: "";
                    width: 30px;
                    height: 15px;
                    background: url(/img/down.svg);
                    background-repeat: no-repeat;
                    background-size: 15px;
                    background-position: center right;
                    position: absolute;
                }
            }
        }
    }
</style>
